import { useEffect, useRef } from 'react';

export default function RenewableEnergy() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const energyTypes = [
    {
      icon: 'ri-sun-line',
      title: '太陽光発電',
      description: '施設の屋根や敷地を活用した太陽光発電システムを導入し、クリーンエネルギーを自家生産しています。'
    },
    {
      icon: 'ri-water-flash-line',
      title: '水力発電',
      description: '地域の水資源を活用した小規模水力発電により、環境に配慮したエネルギー供給を実現しています。'
    },
    {
      icon: 'ri-leaf-line',
      title: 'バイオマスエネルギー',
      description: '地域の農林業から発生する有機資源を活用し、循環型のエネルギー生産に取り組んでいます。'
    }
  ];

  return (
    <section ref={sectionRef} className="py-24 bg-gradient-to-b from-white to-emerald-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 animate-on-scroll opacity-0 translate-y-8 transition-all duration-1000">
          <div className="inline-block px-4 py-2 bg-emerald-100 rounded-full mb-4">
            <span className="text-sm font-semibold text-emerald-700 tracking-wide">RENEWABLE ENERGY</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">再生可能エネルギー事業</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            地域の自然資源を活用した多様な再生可能エネルギーの導入により、<br />脱炭素社会の実現に貢献しています。
          </p>
        </div>

      </div>
    </section>
  );
}